import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export const AccessDenied = () => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-6 bg-background">
    <div className="text-center max-w-md">
      <div className="mx-auto mb-5 w-14 h-14 rounded-full bg-muted flex items-center justify-center">
        <Lock className="h-7 w-7 text-primary" />
      </div>
      <h1 className="font-display text-2xl font-semibold text-foreground mb-3 tracking-tight">
        Access denied
      </h1>
      <p className="text-base text-muted-foreground mb-6 leading-relaxed">
        This add-in can only be accessed from within Microsoft Outlook.
        Please install the add-in and open it from your Outlook mailbox.
      </p>
      <Button asChild className="shadow-fluent-2">
        <a href="/">Go to homepage</a>
      </Button>
    </div>
  </div>
);
